import * as React from 'react'

import { infoCircle } from '../../icons'
import type { CalculatorDkkAmountDataViewModel } from '../../view-models/CalculatorDkkAmountDataViewModel'
import type { CalculatorDkkAmountRowViewModel } from '../../view-models/CalculatorDkkAmountRowViewModel'
import type { TitleAndTextViewModel } from '../../view-models/TitleAndTextViewModel'
import CtaButton from '../CtaButton/CtaButton'
import styles from './calculatorDkkAmountComp-style.css'
import CalculatorInput from './CalculatorInput/CalculatorInput'
import { Button } from '@/components/Button/Button'
import Icon from '@/components/Icon/Icon'
import { InfoButton } from '@/components/Button/InfoButton'

type Row = CalculatorDkkAmountRowViewModel & {
  result: string
  percentageAsNumber: number
}
export type CalculatorDkkAmountDataProps = CalculatorDkkAmountDataViewModel & {
  onOpenModal?: (...args: Array<any>) => any
}
type State = {
  input: string
  rows: Row[]
}
const percentageFormatter = new Intl.NumberFormat('da-DK', {
  style: 'percent',
  minimumFractionDigits: 2,
})
const currencyFormatter = new Intl.NumberFormat('da-DK', {
  style: 'currency',
  currency: 'DKK',
  minimumFractionDigits: 2,
})

class CalculatorDkkAmountComp extends React.Component<
  CalculatorDkkAmountDataProps,
  State
> {
  static displayName = 'CalculatorDkkAmountComp'
  static defaultProps = {}
  state = {
    input: '',
    rows: [],
  }

  openHelpTextModal = (rowHelpText: TitleAndTextViewModel) => {
    this.props.onOpenModal && this.props.onOpenModal(rowHelpText)
  }
  //TODO: any
  handleSubmit: any = (e: Event) => {
    e.preventDefault()
    const amount = parseInt(this.state.input, 10)

    if (Number.isNaN(amount)) {
      return
    }

    this.setState({
      rows: this.props.rows.map((row) => ({
        ...row,
        result: this.calculateResult(row, amount),
        percentageAsNumber: parseFloat(row.percentage),
      })),
    })
  }
  calculateResult = (row: CalculatorDkkAmountRowViewModel, amount: number) => {
    const percentage = parseFloat(row.percentage)

    if (percentage === 0) {
      return '-'
    }

    return currencyFormatter.format(amount * (percentage / 100))
  }

  render() {
    const { label, placeholder, calculateButtonText, helpText } = this.props
    const { input, rows } = this.state

    return (
      <div className={styles.calculatorComp}>
        <form onSubmit={this.handleSubmit}>
          <CalculatorInput
            id={0}
            label={label}
            placeholder={placeholder}
            value={input}
            handleChange={(e) =>
              this.setState({
                input: e.target.value,
              })
            }
            handleClick={() =>
              this.openHelpTextModal({
                text: helpText,
              })
            }
            helpText={helpText}
          />

          <CtaButton
            className={styles.button}
            small
            type="submit"
            link={{
              label: calculateButtonText,
            }}
          />
        </form>
        {!!rows.length && (
          <table className={styles.results}>
            <tbody>
              {rows.map(
                ({ label, percentageAsNumber, helpText, result }, i) => (
                  <tr key={`row-${i}`}>
                    <td>{label}</td>
                    <td className={styles.numeric}>
                      {percentageFormatter.format(percentageAsNumber / 100)}
                    </td>
                    <td className={styles.numeric}>{result}</td>
                    <td className={styles.help}>
                      {helpText && (
                        <InfoButton
                          onClick={() =>
                            this.openHelpTextModal({
                              text: helpText,
                            })
                          }
                          className={styles.infoBtn}
                        />
                      )}
                    </td>
                  </tr>
                ),
              )}
            </tbody>
          </table>
        )}
      </div>
    )
  }
}

export default CalculatorDkkAmountComp
